<div id="password-reset-page" class="login-page container">
  <div class="login-box">
    <div class="logo-container">
      <img id="black-logo" src="/assets/ProductioneerLogoBlack_Transparent.png" />
      <h4 class="product-title">Request Password Reset Link</h4>
    </div>
    <form class="login-form" [formGroup]="forgotPasswordForm" (submit)="onPasswordResetLinkRequest()">
      <p class="reset-instructions">Enter your email address for a link to reset your password.</p>
      <div *ngIf="resultMessage" class="{{resultMessageClass}} | sanitize">
        {{resultMessage}}
      </div>
      <div class="form-group">
        <label name="email">Email</label>
        <input type="email" class="form-control" trim="blur" name="email" placeholder="Productioneer email" formControlName="email" />
        <span *ngIf="forgotPasswordForm['controls'].email.invalid && (forgotPasswordForm['controls'].email.dirty || forgotPasswordForm['controls'].email.touched)" class="text-danger">
          Please enter a valid email address
        </span>
      </div>

      <div class="login-btn-container" *ngIf="!isSubmitting">
        <button type="submit" class="btn btn-primary btn-lg mi4-big-btn" [disabled]="!forgotPasswordForm.valid">Request Link</button>
      </div>
      <div class="login-btn-container" *ngIf="isSubmitting">
        <button disabled class="btn btn-primary btn-lg mi4-big-btn"><span class="spinner-border" role="status"></span> Submitting</button>
      </div>

      <div class="alternate-link-container">
        <a routerLink="/login" id="BackToLoginBtn" class="btn btn-outline-secondary mi4-big-link">Back to Login</a>
      </div>
    </form>
  </div>
</div>
<app-footer></app-footer>

